import env from '@/env';
import { functions } from '@/firebase';
// eslint-disable-next-line no-undef
const stripe = Stripe(env.stripePublicKey);

const getStripeSessionId = functions.httpsCallable('getStripeSessionId');

const APP_BASE_PATH = env.production
  ? 'https://boxx.ie'
  : window.location.origin;

export function checkoutBookingForCustomer(bookingId) {
  return checkoutBooking(bookingId, {
    success_url: urlForRoute(
      `/booking-confirmation?bid=${bookingId}&success=true`
    ),
    cancel_url: urlForRoute(`/book?redirect=true&bid=${bookingId}&cancel=true`)
  });
}

export function checkoutBookingForAdmin(bookingId, storeId) {
  return checkoutBooking(bookingId, {
    success_url: urlForRoute(
      `/admin/stores/${storeId}/bookings/edit/${bookingId}?redirect=true&stripe=true&success=true`
    ),
    cancel_url: urlForRoute(
      `/admin/stores/${storeId}/bookings/edit/${bookingId}?redirect=true&stripe=true&cancel=true`
    )
  });
}

async function checkoutBooking(booking_id, sessionOpts) {
  const response = await getStripeSessionId({ booking_id, sessionOpts });
  stripe.redirectToCheckout({ sessionId: response.data });
}

function urlForRoute(route) {
  return `${APP_BASE_PATH}${route}`;
}

export default stripe;
